module.exports = __webpack_public_path__ + "img/momo_1.26976d18.png";